import { render, staticRenderFns } from "./business-ecology.vue?vue&type=template&id=57af5f74&scoped=true&"
import script from "./business-ecology.vue?vue&type=script&lang=js&"
export * from "./business-ecology.vue?vue&type=script&lang=js&"
import style0 from "./business-ecology.vue?vue&type=style&index=0&id=57af5f74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57af5f74",
  null
  
)

export default component.exports